import { useForm } from '@mantine/form';
import { useEffect, useState } from 'react';
import {
	validateDate,
	validateEndDate,
	validateNotEmpty,
	validateNumber,
	validateText,
} from '../../../util/validation/commonValidation';
import type { UpsertPosMessageDto } from '../types/PosMessageDto';

const defaultUpsertPosMessage: UpsertPosMessageDto = {
	id: 0,
	branchId: '',
	tillNo: '',
	startDate: undefined,
	endDate: undefined,
	days: [],
	posMessage: '',
	skuid: '',
	moneyValue: '',
	qty: '',
};

export function useUpsertPosMessageForm(
	upsertPosMessage: UpsertPosMessageDto = defaultUpsertPosMessage,
) {
	const [inputs, setInputs] = useState<UpsertPosMessageDto>(upsertPosMessage);

	const [previousBranchId, setPreviousBranchId] = useState(
		upsertPosMessage.branchId,
	);

	const form = useForm<UpsertPosMessageDto>({
		mode: 'uncontrolled',
		initialValues: inputs,
		validate: {
			startDate: (value) => validateDate(value, false),
			endDate: (value, values) =>
				validateEndDate(value, false, values.startDate),
			branchId: (value) =>
				validateNumber(value, false, 0, 10000000, 'Branch', false),
			tillNo: (value) => validateNotEmpty(value, 'Till'),
			qty: (value) => validateNumber(value, false, 0, 10000, 'Quantity', false),
			posMessage: (value) => validateText(value, false, 'Type', 255),
			moneyValue: (value) =>
				validateNumber(value, false, 0, 100000000, 'Value', false),
			skuid: (value) => validateText(value, false, 'SKUID', 25),
			days: (value) => {
				if (!value || value.length < 1) {
					return 'Please select at least one day';
				}
			},
		},
		onValuesChange: (v) => {
			setInputs(v);
		},
	});

	useEffect(() => {
		if (previousBranchId !== inputs.branchId) {
			form.setValues({ tillNo: '' });
		}

		setPreviousBranchId(inputs.branchId);
	}, [inputs.branchId]);

	return { form, inputs };
}
